// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../services/api'

const PACKAGES = [
  { id: 'pack_50',  credits: 50,  price: '4.99€', label: '50 SMS' },
  { id: 'pack_100', credits: 100, price: '7.99€', label: '100 SMS' },
  { id: 'pack_200', credits: 200, price: '14.99€', label: '200 SMS' },
]

export default function SmsCredits() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const [credits, setCredits] = useState<number | null>(null)
  const [logs, setLogs] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [buyingId, setBuyingId] = useState<string | null>(null)
  const [showLogs, setShowLogs] = useState(false)
  const [toast, setToast] = useState<{ msg: string; ok: boolean } | null>(null)

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return }
    Promise.all([
      api.get('/sms/credits'),
      api.get('/sms/logs'),
    ]).then(([c, l]) => {
      setCredits(c.data.credits)
      setLogs(l.data.logs || [])
    }).finally(() => setLoading(false))

    if (searchParams.get('success') === '1') {
      setToast({ msg: t('smsCredits.paySuccess'), ok: true })
      setTimeout(() => {
        setToast(null)
        api.get('/sms/credits').then(r => setCredits(r.data.credits))
      }, 4000)
    }
    if (searchParams.get('cancelled') === '1') {
      setToast({ msg: t('smsCredits.payCancelled'), ok: false })
      setTimeout(() => setToast(null), 3000)
    }
  }, [navigate])

  const handleBuy = async (packageId: string) => {
    setBuyingId(packageId)
    try {
      const res = await api.post('/sms/packages/buy', { packageId })
      window.location.href = res.data.checkoutUrl
    } catch {
      setToast({ msg: t('smsCredits.payError'), ok: false })
      setTimeout(() => setToast(null), 3000)
      setBuyingId(null)
    }
  }

  const creditColor = credits === null ? '#888' : credits > 10 ? '#16a34a' : credits > 3 ? '#ea580c' : '#dc2626'

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
      {/* Header */}
      <div style={{ backgroundColor: '#fff', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate('/profile')} style={{ background: 'none', border: 'none', color: '#2D7A3A', fontSize: 22, cursor: 'pointer', lineHeight: 1, padding: 0 }}>‹</button>
        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1a1a1a' }}>{t('smsCredits.title')}</h1>
      </div>

      {/* Toast */}
      {toast && (
        <div style={{ position: 'fixed', top: 70, left: '50%', transform: 'translateX(-50%)', zIndex: 999, backgroundColor: toast.ok ? '#16a34a' : '#dc2626', color: '#fff', padding: '12px 24px', borderRadius: 12, fontSize: 14, fontWeight: 600, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', whiteSpace: 'nowrap' }}>
          {toast.msg}
        </div>
      )}

      <div style={{ padding: 20, maxWidth: 480, margin: '0 auto' }}>

        {/* Zostatok */}
        <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 24, marginBottom: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.05)', textAlign: 'center' }}>
          {loading ? (
            <div style={{ height: 60, backgroundColor: '#f5f5f5', borderRadius: 12, marginBottom: 8 }} />
          ) : (
            <>
              <div style={{ fontSize: 56, fontWeight: 800, color: creditColor, lineHeight: 1 }}>{credits}</div>
              <div style={{ fontSize: 16, color: '#888', marginTop: 4, marginBottom: 12 }}>{t('smsCredits.remaining')}</div>
              {credits === 0 && (
                <div style={{ backgroundColor: '#fef2f2', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#dc2626', fontWeight: 500 }}>
                  {t('smsCredits.noCredits')}
                </div>
              )}
              {credits > 0 && credits <= 5 && (
                <div style={{ backgroundColor: '#fff7ed', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#ea580c', fontWeight: 500 }}>
                  {t('smsCredits.lowCredits')}
                </div>
              )}
            </>
          )}
          <p style={{ margin: '12px 0 0', fontSize: 12, color: '#aaa' }}>{t('smsCredits.freeOnRegister')}</p>
        </div>

        {/* Kúpiť kredity */}
        <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 20, marginBottom: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
          <h2 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>{t('smsCredits.buyTitle')}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {PACKAGES.map(pkg => (
              <div key={pkg.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderRadius: 14, border: '1.5px solid #e5e7eb', backgroundColor: '#fafafa' }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>{pkg.label}</div>
                  <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>{pkg.price}</div>
                </div>
                <button
                  onClick={() => handleBuy(pkg.id)}
                  disabled={buyingId !== null}
                  style={{ padding: '10px 20px', borderRadius: 10, border: 'none', backgroundColor: buyingId === pkg.id ? '#a7d7b0' : '#2D7A3A', color: '#fff', fontSize: 14, fontWeight: 600, cursor: buyingId !== null ? 'not-allowed' : 'pointer', minWidth: 80 }}
                >
                  {buyingId === pkg.id ? '...' : t('smsCredits.buyBtn')}
                </button>
              </div>
            ))}
          </div>
          <p style={{ margin: '14px 0 0', fontSize: 12, color: '#aaa', textAlign: 'center' }}>{t('smsCredits.stripeInfo')}</p>
        </div>

        {/* História SMS */}
        <div style={{ backgroundColor: '#fff', borderRadius: 20, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
          <button
            onClick={() => setShowLogs(v => !v)}
            style={{ width: '100%', padding: '16px 20px', border: 'none', background: 'none', textAlign: 'left', fontSize: 15, fontWeight: 600, color: '#1a1a1a', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'inherit' }}
          >
            {t('smsCredits.historyTitle')}
            <span style={{ color: '#d1d5db', fontSize: 18 }}>{showLogs ? '∨' : '›'}</span>
          </button>
          {showLogs && (
            <div style={{ borderTop: '1px solid #f5f5f5' }}>
              {logs.length === 0 ? (
                <p style={{ padding: '16px 20px', margin: 0, color: '#aaa', fontSize: 14 }}>{t('smsCredits.noLogs')}</p>
              ) : logs.map((log: any) => (
                <div key={log.id} style={{ padding: '12px 20px', borderBottom: '1px solid #f9f9f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
                  <div>
                    <div style={{ fontSize: 13, color: '#1a1a1a', fontWeight: 500 }}>
                      {log.toNumber.slice(0, -4).replace(/./g, '*') + log.toNumber.slice(-4)}
                    </div>
                    <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>
                      {new Date(log.createdAt).toLocaleString(lang === 'en' ? 'en-GB' : 'sk-SK', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                  <span style={{
                    fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 6,
                    backgroundColor: log.status === 'sent' ? '#f0fdf4' : log.status === 'blocked_no_credits' ? '#fef2f2' : '#fff7ed',
                    color: log.status === 'sent' ? '#16a34a' : log.status === 'blocked_no_credits' ? '#dc2626' : '#ea580c',
                  }}>
                    {log.status === 'sent' ? t('smsCredits.statusSent') : log.status === 'blocked_no_credits' ? t('smsCredits.statusBlocked') : t('smsCredits.statusError')}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
